import { getSettingsFromUrl } from '../utils/get-settings-from-url'
import { logger } from './logger'
import { DEFAULT_PAGE_QUERY_PARAM_PREFIX, PAGE_QUERY_UNLOCK_KEY } from '../config'

/**
 * Loads settings from the current page URL.
 * If the page URL contains the unlock key, the settings will be loaded from the URL.
 * Otherwise, the settings will be returned as-is.
 *
 * @param settings
 */
export function loadSettingsFromPageUrl<T> (settings: T): T {
  const targetUrl = new URL(window.location.toString())

  // check to see if the page location includes the unlock key
  if (!targetUrl.searchParams.has(PAGE_QUERY_UNLOCK_KEY)) return settings
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-nullish-coalescing
  const unlockKey = targetUrl.searchParams.get(PAGE_QUERY_UNLOCK_KEY) || null
  logger.debug('Loading settings from page URL')
  return getSettingsFromUrl(targetUrl, settings, unlockKey ?? DEFAULT_PAGE_QUERY_PARAM_PREFIX)
}
